import { ReactComponent as ZhuanyecanzhaoSvg } from '@/commons/icons/menu/zhuanyecanzhao.svg';
import { ReactComponent as ZhouxianSvg } from '@/commons/icons/menu/zhouxian.svg';
import { ReactComponent as YinyongloucengSvg } from '@/commons/icons/menu/yinyonglouceng.svg';
import { ReactComponent as YinyongzhouwangSvg } from '@/commons/icons/menu/yinyongzhouwang.svg';

import { ReactComponent as ChazuoSvg } from '@/commons/icons/menu/electricity/chazuo.svg';
import { ReactComponent as DengjuSvg } from '@/commons/icons/menu/electricity/dengju.svg';
import { ReactComponent as DianxianSvg } from '@/commons/icons/menu/electricity/dianxian.svg';
import { ReactComponent as DianyuanSvg } from '@/commons/icons/menu/electricity/dianyuan.svg';
import { ReactComponent as KaiguanSvg } from '@/commons/icons/menu/electricity/kaiguan.svg';
import { ReactComponent as PeidianxiangSvg } from '@/commons/icons/menu/electricity/peidianxiang.svg';


export default function ElectricityMenu() {

    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongzhouwangSvg /></div>
                                <div className='name'>引用轴网</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhouxianSvg /></div>
                                <div className='name'>轴线</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YinyongloucengSvg /></div>
                                <div className='name'>引用楼层</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><ZhuanyecanzhaoSvg /></div>
                                <div className='name'>专业参照</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><DianyuanSvg /></div>
                                <div className='name'>电源</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><DianxianSvg /></div>
                                <div className='name'>电线</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ChazuoSvg /></div>
                                <div className='name'>插座</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><KaiguanSvg /></div>
                                <div className='name'>开关</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><DengjuSvg /></div>
                                <div className='name'>灯具</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><PeidianxiangSvg /></div>
                                <div className='name'>配电箱</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}